import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    children: ReactNode
    tone?: 'light' | 'dark'
    className?: string
}

export const SectionLabel: FC<SectionLabelProps> = ({ children, tone = 'light', className }): ReactNode => {
    return (
        <p
            className={cn(
                'flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.18em]',
                tone === 'dark' ? 'text-white/60' : 'text-muted-foreground',
                className
            )}
        >
            <span
                aria-hidden='true'
                className={cn('size-1.5 shrink-0', tone === 'dark' ? 'bg-highlight' : 'bg-brand')}
            />
            {children}
        </p>
    )
}
